module.exports = __webpack_public_path__ + "static/media/material-ui.d2b1e190.png";